export default "__VITE_ASSET__CqzIYOIR__"